module.exports = __webpack_public_path__ + "img/jk5.5c17ae46.png";